export const typeDefs = `
  ArchivedGrowthRewardHistorySortType
  = date
  | platformName
  | personalReward
  | personalRewardUsdAmt
  | growthReward
  | totalReward

  ArchivedGrowthRewardHistoryFilerInput {
    date: [String]
    merchantName: [String]
    platformName: [String]
    personalReward: [Float]
    personalRewardUsdAmt: [Float]
    growthReward: [Float]
    growthRewardPct: [Float]
    totalReward: [Float]
  }
`;
